import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d574761c")

_pushScopeId("data-v-d574761c")
const _hoisted_1 = { class: "dialog__content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h4", { class: "dialog__title" }, "Informations reliées au compte", -1)
const _hoisted_3 = { class: "dialog__list" }
const _hoisted_4 = { class: "dialog__item" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-user-o" }, null, -1)
const _hoisted_6 = { class: "dialog__item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-mail" }, null, -1)
const _hoisted_8 = { class: "dialog__item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-lock" }, null, -1)
const _hoisted_10 = { class: "dialog__item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "icon-lock" }, null, -1)
const _hoisted_12 = { class: "dialog__notes" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-attention" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Le mot de passe doit etre réinitialisé ")
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-attention" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Erreur de sauvegarde des informations ")
const _hoisted_17 = { class: "footer__buttons" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "icon-upload" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Sauvegarder ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.preferencesDialogVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: true,
            headerTitle: "Gestion du Compte",
            tabindex: "0",
            onClose: _ctx.closeDialog,
            onKeyup: _withKeys(_ctx.savePreferences, ["enter"]),
            onKeydown: _withKeys(_ctx.closeDialog, ["esc"])
          }, {
            body: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      placeholder: _ctx.user,
                      tabindex: "0",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
                    }, null, 8, ["placeholder"]), [
                      [_vModelText, _ctx.name]
                    ])
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      placeholder: _ctx.email,
                      tabindex: "1",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.username = $event))
                    }, null, 8, ["placeholder"]), [
                      [_vModelText, _ctx.username]
                    ])
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _withDirectives(_createVNode("input", {
                      type: "password",
                      tabindex: "2",
                      placeholder: "Nouveau mot de passe",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createVNode("input", {
                      type: "password",
                      tabindex: "3",
                      placeholder: "Confirmation du mot de passe",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmPassword = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.confirmPassword]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", {
                    class: "notes notes--warn",
                    style: {
                                'visibility': _ctx.passwordChangeAction? 'visible': 'hidden'
                            }
                  }, [
                    _hoisted_13,
                    _hoisted_14
                  ], 4),
                  _createVNode("div", {
                    class: "notes notes--error",
                    style: {
                                'visibility': _ctx.saveError? 'visible': 'hidden'
                            }
                  }, [
                    _hoisted_15,
                    _hoisted_16
                  ], 4)
                ])
              ])
            ]),
            footer: _withId(() => [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", {
                  class: "button button--action button--grow",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.savePreferences && _ctx.savePreferences(...args)))
                }, [
                  _createVNode("span", null, [
                    _hoisted_18,
                    _hoisted_19,
                    _createVNode("i", {
                      class: {
                                    'icon-right-open': _ctx.saveReady,
                                    'icon-spinner animate-spin': _ctx.saveLoading
                                }
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onKeyup", "onKeydown"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})